import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import { store } from './Store';
// Styles
import 'perfect-scrollbar/css/perfect-scrollbar.css';
import "bootstrap/dist/css/bootstrap.css";
import "@fortawesome/fontawesome-free/css/all.css";
import "./Axios.js";
import $ from "jquery";
import 'datatables.net';
import 'datatables.net-dt';
// import 'datatables.net-dt/css/jquery.dataTables.css'; 
import jQueryPlugin from './plugins/jquery-plugin';
import DataTablesPlugin from './plugins/dataTablesPlugin';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
dayjs.extend(relativeTime);

// import 'https://maps.googleapis.com/maps/api/js?key=AIzaSyC0Qn35GGmFwlcIHeAdTL2_gpweBdNo5YI&libraries=places';
// import '../public/vendor/jquery.cookie';
// import '../public/vendor/perfect-scrollbar';
// import '../public/vendor/switchery';
// import '../public/vendor/chart.js';
// import '../public/vendor/jquery.sparkline';
// import '../public/vendor/maskedinput';
// import '../public/vendor/bootstrap-touchspin';
// import '../public/vendor/autosize';
// import '../public/vendor/select2';
// import '../public/vendor/bootstrap-datepicker';
// import '../public/vendor/bootstrap-timepicker';
// import '../public/vendor/bootstrap-fileinput';
// import '../public/vendor/selectFx'
// import VueAwesomePaginate from "vue-awesome-paginate";
// import "vue-awesome-paginate/dist/style.css";
// import Paginate from "vuejs-paginate-next";


const app = createApp(App);
// Disable Vue's error overlay in development mode
if (process.env.NODE_ENV === 'development') {
    app.config.errorHandler = (err, vm, info) => {
        console.error('Vue Error Handler:', err);
        console.error('Component:', vm);
        console.error('Error Info:', info);
        // Display a user-friendly error message
        store.setErrorMessage('An unexpected error occurred. Please try again later.');
        // Return false to prevent the error overlay from showing
        return false;
    };
}
// Global JavaScript Error Handler (catches all errors)
window.onerror = function (message, source, lineno, colno, error) {
    console.error('Global Error Handler:', message);
    console.error('Source:', source);
    console.error('Line Number:', lineno);
    console.error('Column Number:', colno);
    console.error('Error Object:', error);

    store.setErrorMessage('An unexpected error occurred. Please try again later.');
    // Return true to prevent the error from being logged to the console
    return true;
};
// Global Warn Handler (optional)
app.config.warnHandler = (msg, vm, trace) => {
    console.warn('Vue warning:', msg);
    console.warn('Component:', vm);
    console.warn('Trace:', trace);
};
app.config.globalProperties.$ = $;
app.config.globalProperties.jQuery = $;
app.use(jQueryPlugin);
app.use(DataTablesPlugin);
app.use(router);
// app.use(store);

if (localStorage.getItem("access_token")) {
    const role = localStorage.getItem("userRole");
    const permissions = JSON.parse(localStorage.getItem("userPermissions"));

    // Set user role and permissions in the store
    store.setUserRole(role);
    store.setUserPermissions(permissions);
    store.setLoggedIn(true);
}
app.mount('#app');


